import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalVariable } from "app/global/global";
import {
  CrearOdontogramaPayload,
  UltimoOdontograma,
  EstadoOdontograma,
} from "app/models/odontograma.interface";
import { EstadoPeriodontograma } from "app/models/periodontograma.interface";

@Injectable({ providedIn: "root" })
export class OdontogramaService {
  private base = GlobalVariable.BASE_API_URL + "api/odontograma";

  constructor(private http: HttpClient) {}

  ultimoPorPaciente(idPaciente: number): Observable<UltimoOdontograma> {
    return this.http.get<UltimoOdontograma>(`${this.base}/ultimo-por-paciente/${idPaciente}`);
  }

  crear(payload: CrearOdontogramaPayload): Observable<{ id: number }> {
    return this.http.post<{ id: number }>(`${this.base}`, payload);
  }

  actualizar(
    id: number,
    payload: {
      odontograma_estado?: EstadoOdontograma;
      periodontograma_estado?: EstadoPeriodontograma;
      observaciones?: string | null;
    },
  ): Observable<{ id: number }> {
    return this.http.put<{ id: number }>(`${this.base}/${id}`, payload);
  }
}
